// extracted by mini-css-extract-plugin
module.exports = {"chartWrapper":"chart-antd_chartWrapper__VqRAl"};